import React from 'react';
import ReactDOM from 'react-dom';
import './styles.scss';
import 'jsgrid'
import 'jsgrid/css/jsgrid.css'
import 'jsgrid/css/theme.css'
import TaxonomyTree from './components/TaxonomyTree';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

if(document.getElementById('taxonomy-tree')) {
    ReactDOM.render(  <React.StrictMode>
        <DndProvider backend={HTML5Backend}>
        <TaxonomyTree />
        </DndProvider>
    </React.StrictMode>, document.getElementById('taxonomy-tree'));
}
